import { getSelectedLanguage } from '@frontend/translate';
import type { IToesturenTherapielandModules } from '../../OSASVC/contact/v2/OsasvcV2RequestAddEdit';

export function getToesturenValues(toesturen: IToesturenTherapielandModules = {} as IToesturenTherapielandModules) {
    const translate = getSelectedLanguage();

    const toesturenValues: string[] = [];
    Object.entries(toesturen).forEach(([therapieKey, therapieValue]) => {
        if (therapieValue) {
            toesturenValues.push(
                translate.toesturenKsyosMedicalCenter[therapieKey as keyof IToesturenTherapielandModules]
            );
        }
    });

    return toesturenValues.join(', ');
}
